import { z } from "zod/v4";

export const ShippingTestMethodDeleteTargetKindDtoSchema = z.enum([
  "canonical_method",
  "participant_method",
  "synthetic_free_condition",
  "synthetic_rate_definition",
]);

const ShippingTestMethodConditionValueDtoSchema = z.union([
  z.object({
    __typename: z.literal("MoneyV2"),
    amount: z.string(),
    currencyCode: z.string().nullish(),
  }),
  z.object({
    __typename: z.literal("Weight"),
    unit: z.string(),
    value: z.number(),
  }),
]);

export const ShippingTestMethodFreeConditionDtoSchema = z.object({
  subject: z.string(),
  min: ShippingTestMethodConditionValueDtoSchema.nullish(),
  max: ShippingTestMethodConditionValueDtoSchema.nullish(),
});

export const ShippingTestMethodDefinitionDtoSchema = z.object({
  id: z.uuid().optional(),
  deliveryProfileId: z.string(),
  deliveryLocationGroupId: z.string(),
  deliveryZoneId: z.string(),
  methodDefinitionId: z.string().nullish(),
  canonicalMethodId: z.string().optional(),
  deleteTargetKind: ShippingTestMethodDeleteTargetKindDtoSchema.optional(),
  deleteTargetRateDefinitionId: z.string().optional(),
  deleteTargetFreeCondition:
    ShippingTestMethodFreeConditionDtoSchema.optional(),
});

export type ShippingTestMethodDefinitionDto = z.infer<
  typeof ShippingTestMethodDefinitionDtoSchema
>;
